exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".quillRow {\n  margin: 30px 0px 50px 0px;\n}\n", ""]);

// exports
